(function () {
  const root = document.querySelector('[data-fps-root]');
  if (!root) return;

  if (window.location.pathname.includes('pets-hotel-boarding')) {
    const hero =
      'https://images.unsplash.com/photo-1560807707-8cc77767d783?auto=format&fit=crop&w=900&q=80';
    const intro =
      'https://images.unsplash.com/photo-1530281700549-e82e7bf110d6?auto=format&fit=crop&w=900&q=80';
    const heroImg = root.querySelector('.fps-shero__media img.fps-img');
    const introImg = root.querySelector('.fps-land__intro-media img.fps-img');
    if (heroImg) heroImg.src = hero;
    if (introImg) introImg.src = intro;
  }

  if (window.location.pathname.includes('pet-services')) {
    const boardingImg =
      'https://images.unsplash.com/photo-1560807707-8cc77767d783?auto=format&fit=crop&w=700&q=80';
    root.querySelectorAll('a.fps-svc[href*="pets-hotel-boarding"] .fps-svc__media img.fps-img').forEach((img) => {
      img.src = boardingImg;
    });
  }

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  root.querySelectorAll('img.fps-img').forEach((img) => {
    const done = () => img.classList.add('is-loaded');
    if (img.complete && img.naturalWidth > 0) done();
    else {
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    }
  });

  const items = root.querySelectorAll('[data-reveal]');
  const show = (el) => el.classList.add('in');
  if (reduced || !('IntersectionObserver' in window)) {
    items.forEach(show);
  } else {
    items.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92) show(el);
    });
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    items.forEach((el) => io.observe(el));
  }

  const form = root.querySelector('[data-fps-book-form]');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const action = form.getAttribute('action');
      if (!action) return;
      const service = form.querySelector('[name="service"]');
      const location = form.querySelector('[name="location"]');
      const params = new URLSearchParams();
      if (service && service.value) params.set('service', service.value);
      if (location && location.value) params.set('location', location.value);
      const qs = params.toString();
      window.location.href = qs ? `${action}?${qs}` : action;
    });
  }
})();
